//Biology experimets data

export const class9 = [
    {
        id:1,
        title:"Osmosis",
        img:"https://pubs.rsc.org/en/Image/Get?imageInfo.ImageType=GA&imageInfo.ImageIdentifier.ManuscriptID=C8CS00420J&imageInfo.ImageIdentifier.Year=2019",
        description:"It is a special type of diffusion in which movement of water takes place due to difference in water molecule concentration between the adsorbant and the imbibant. For e.g., the dry plant part or dry seeds when placed in water increases in size or swells.Mass percentage of water imbibed by raisins can be calculated as:Mass % of water imbibed=Mass of the Water absorbed by the raisin/Initial mass of the raisin",
        videolink:"https://www.youtube.com/watch?v=GxyfS1v77lU",
        explink:"https://simmer.io/@Buoyancy/osmosis-raisin",
        theory:"https://lakshya3119.github.io/Bio/All-Bio-Class9/exp-3.html"
    },
    {
        id:2,
        title:"Slide of Onion peel and cheek cells",
        img:"https://images.pexels.com/photos/144206/pexels-photo-144206.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        description:"With the help of the toothpick scrap the inner side of the cheek to get some epithelial cells. Place the scrappings in a drop of water over a clean slide. ... Add a drop of glycerine on the slide. With the help of needle, gently place the coverslip over the slide to avoid entry of air bubbles",
        videolink:"https://youtu.be/UyP3-ICurVk",
        explink:"",
        theory:"https://www.cbsesamplepapers.info/cbse/cbse-class-9-science-practical-skills-slide-of-onion-peel-and-cheek-cells"
    },
    {
        id:3,
        title:"Plants and animal tissue",
        img:"https://images.pexels.com/photos/2062424/pexels-photo-2062424.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        description:"Plant tissues include xylem, phloem, collenchyma, sclerenchyma, epidermis and meristematic tissue. Animal tissues include epithelial tissue, connective tissue, muscle tissue and nerve tissue. ... The leaf is an example of a plant organ and its structure is adapted to its role in photosynthesis.",
        videolink:"https://youtu.be/qTtKi4rvbI4",
        explink:"",
        theory:"https://www.cbsesamplepapers.info/cbse/cbse-class-9-science-practical-skills-plant-and-animal-tissues"
    }

]


export const class10 = [
    {
        id:1,
        title:"Life cycle of mosquito",
        img:"https://www.pexels.com/photo/black-mosquito-on-person-s-skin-169357/",
        description:"All mosquito species go through four distinct stages during their life cycle: Egg - hatches when exposed to water. Larva - (plural: larvae) wriggler lives in water; molts several times; most species surface to breathe air. Pupa - (plural: pupae) tumblerdoes not feed; stage just before emerging as adult",
        videolink:"https://youtu.be/mroLfTPhL90",
        explink:"",
        theory:"https://lakshya3119.github.io/Bio/All-Bio-Class9/exp-1.html"
    },
    {
        id:2,
        title:"External features of roots",
        img:"https://www.pexels.com/photo/photo-of-potted-plants-on-wooden-table-4503273/",
        description:"The study reveals that dicot plants have tap root system, broad leaves with reticulate venation, five or in multiple of five sepals, petals and stamens in their flowers whereas monocots have fibrous root, narrow leaves with parallel venation, three or in multiple of three sepals, petals and stamens in their flowers",
        videolink:"https://youtu.be/8IjN1ZAkIn8",
        explink:"",
        theory:"https://lakshya3119.github.io/Bio/All-Bio-Class9/exp-2.html"
    },
    {
        id:3,
        title:"photosynthesis",
        img:"https://www.pexels.com/photo/summer-leaf-tree-dew-5403480/",
        description:"Photosynthesis is a process used by plants and other organisms to convert light energy into chemical energy that, through cellular respiration, can later be released to fuel the organism's metabolic activities.",
        videolink:"https://youtu.be/3RBl3xqnCrc",
        explink:"",
        theory:"https://www.cbsetuts.com/ncert-class-10-science-lab-manual-light-necessary-photosynthesis/"
    }
]


export const class11 = [
    {
        id:1,
        title:"How to Separate Plant Pigments Using Paper Chromatography",
        img:"https://qph.fs.quoracdn.net/main-qimg-9813b609f5034ed0d6e5c1f2da5c5976",
        description:"Plants carry out the process of photosynthesis, during which light energy from the sun is converted into chemical energy (food). The capturing of light energy is carried out by molecules known as pigments, which are present within the plant cells.",
        videolink:"https://youtu.be/ej2zXOwASVI",
        explink:"",
        theory:"https://www.depts.ttu.edu/ciser/science-teacher-resources/traveling-lab/curriculum/plants/Plant_Pigment_Chromatography.pdf"
    },
    {
        id:2,
        title:"A Study Focusing on the Distribution of Stomata in the Lower and Upper Surfaces of the Leaves",
        img:"https://pediaa.com/wp-content/uploads/2017/10/Difference-Between-Stomata-of-Monocot-and-Dicot-Plants-1.jpg",
        description:"Stomata are tiny openings that are located in the young shoots of plants and epidermis of the leaves. They govern the gas exchange process in plants. The structure of the stomata includes a pair of specialized cells that are found girdling around the opening. These cells are termed as guard cells and are responsible to check and regulate the size of the closing and opening of the stomata.",
        videolink:"https://youtu.be/v53Zf2MhrwE",
        explink:"",
        theory:"https://www.selfstudys.com/uploads/pdf/VV9FiTgZV03gsfnlpWSz.pdf"
    },
    {
        id:3,
        title:"Understanding the Rate of Respiration In Leaf Tissue, Flower Buds And In Germinating Seeds",
        img:"https://hi-static.z-dn.net/files/db6/40ab787e3ac8e67db79b5684d11a41be.png",
        description:"The rate of respiration can be estimated with the help of a Ganong’s respirometer ",
        videolink:"https://youtu.be/k1CTrQy8fEU",
        explink:"",
        theory:"https://surmount.schooloncloud.com/DocsUpload/1/HomeworkUpload/f14856c9-a9d9-4815-8d19-ba28ded9ac59.pdf"
    }

]

export const class12 = [
    {
        id:1,
        title:"To study soil samples from two different sites and analyse their properties such as texture, moisture content, water-retaining capacity and pH. Also, the study aims to correlate the plants found in such soil.",
        img:"http://img.brainkart.com/extra3/Ewi6yC7.jpg",
        description:"When the universal pH indicator is added to the test tube containing the soil solution, the colour changes. These colour changes can be tracked using the pH colour chart. Roadside soil has a pH level of 7 while garden soil has a pH level of 6. Most crops grow between pH levels of 6.0 and 7.0.",
        videolink:"https://youtu.be/eftNwlrQ7Fo",
        explink:"",
        theory:"http://www.stjohnsschoolkota.edu.in/DocTypes/Documents/XII-BIOLOGY-PRACTICAL.pdf"
    },
    {
        id:2,
        title:"Collect And Study The Properites Of Water Samples From Two Different Water Bodies",
        img:"https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Aubach_%28Wiehl%29_nahe_dem_Weiherdamm_in_Wildbergerh%C3%BCtte.jpg/330px-Aubach_%28Wiehl%29_nahe_dem_Weiherdamm_in_Wildbergerh%C3%BCtte.jpg",
        description:"To study pH level, clarity and presence of microbes and other living organisms from two different water bodies.",
        videolink:"https://youtu.be/RVpSPidRhM8",
        explink:"",
        theory:"https://ncert.nic.in/pdf/publication/sciencelaboratorymanuals/classXII/biology/lelm213.pdf"
    },
    {
        id:3,
        title:"Pollen Germination on Stigma through a Permanent Slide",
        img:"https://farm5.staticflickr.com/4362/37104214495_38422f162b_o.png",
        description:"To observe pollen germination on stigma through a permanent slide.Pollination refers to the transfer of pollen grains from the anther of a flower to the stigma of the same or different flower through biotic or abiotic means.",
        videolink:"https://youtu.be/XwV33sxktCg",
        explink:"",
        theory:"https://ncert.nic.in/pdf/publication/sciencelaboratorymanuals/classXII/biology/lelm202.pdf"
    }

]

